import React from 'react';
export function BenefitsSection() {
  return <section className="w-full bg-white py-16 md:py-24 px-6" data-id="element-18">
      <div className="max-w-2xl mx-auto" data-id="element-19">
        <h3 className="font-serif text-2xl md:text-3xl text-charcoal-700 mb-8 text-center uppercase tracking-wide" data-id="element-20">
          Vas a poder:
        </h3>

        <div className="flex justify-center" data-id="element-21">
          <ul className="space-y-4 text-lg md:text-xl text-charcoal-500 font-light" data-id="element-22">
            {['Entender mejor a tu bebé', 'Sentirte más segura en el día a día', 'Saber cómo actuar en situaciones comunes', 'Reducir la ansiedad y la incertidumbre', 'Disfrutar más este proceso'].map((benefit, index) => <li key={index} className="flex items-center gap-4" data-id="element-23">
                <span className="text-xl" data-id="element-24">🐚</span>
                <span data-id="element-25">{benefit}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}